import { useToast } from '@/contexts/ToastContext';
import { Toast } from './toast';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div
      className="fixed top-0 z-[100] flex max-h-screen w-full flex-col-reverse gap-2 p-4 pointer-events-none sm:bottom-0 sm:right-0 sm:top-auto sm:flex-col sm:max-w-[360px]"
      aria-label="Notifications"
    >
      {toasts.map((toast) => (
        <Toast key={toast.id} toast={toast} onDismiss={dismiss} />
      ))}
    </div>
  );
}
